import React from 'react';
import styled, { keyframes } from 'styled-components';
import { PageStyle } from '../components/styled/PageStyle';
import { H1 } from '../components/styled/Title';

const swing = keyframes`
    0% { transform: rotate(10deg); }
    100% { transform: rotate(-10deg); }
`;

const trolleyMove = keyframes`
    0% { left: -50px; }
    50% { left: 130px; }
    100% { left: -50px; }
`;

const CraneContainer = styled.div`
    position: relative;
    width: 300px;
    height: 300px;
    margin: 50px auto;
    border-bottom: 4px solid #333;
`;

const Base = styled.div`
    position: absolute;
    bottom: 0;
    left: 135px;
    width: 30px;
    height: 20px;
    background-color: #333;
`;

const Mast = styled.div`
    position: absolute;
    bottom: 20px;
    left: 145px;
    width: 10px;
    height: 200px;
    background-color: #f1c40f;
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: repeating-linear-gradient(
            45deg,
            transparent,
            transparent 10px,
            rgba(0,0,0,0.1) 10px,
            rgba(0,0,0,0.1) 20px
        );
    }
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: -5px;
        width: 20px;
        height: 20px;
        background-color: #f1c40f;
        border-radius: 50%;
        border: 2px solid #333;
    }
`;

const JibContainer = styled.div`
    position: absolute;
    top: 80px;
    left: 150px;
    transform-origin: left center;
`;

const Jib = styled.div`
    position: absolute;
    top: -5px;
    left: -60px;
    width: 210px;
    height: 8px;
    background-color: #f1c40f;
    border: 1px solid #333;
    &::after {
        content: '';
        position: absolute;
        top: -15px;
        left: 60px;
        width: 2px;
        height: 15px;
        background-color: #333;
    }
`;

const CounterJib = styled.div`
    position: absolute;
    top: -5px;
    left: -80px;
    width: 80px;
    height: 8px;
    background-color: #f1c40f;
    border: 1px solid #333;
`;

const Trolley = styled.div`
    position: absolute;
    top: 5px;
    width: 20px;
    height: 10px;
    background-color: #333;
    animation: ${trolleyMove} 5s linear infinite;
`;

const Line = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
    width: 1px;
    height: 60px;
    background-color: #333;
    transform-origin: top center;
    animation: ${swing} 2s ease-in-out infinite alternate;
`;

const Hook = styled.div`
    position: absolute;
    bottom: -10px;
    left: -5px;
    width: 10px;
    height: 10px;
    border: 2px solid #333;
    border-top: none;
    border-radius: 0 0 5px 5px;
`;

const Load = styled.div`
    position: absolute;
    bottom: -30px;
    left: -10px;
    width: 20px;
    height: 20px;
    background-color: #e67e22;
    border-radius: 2px;
`;

const P = styled.p`
    color: ${({ theme }) => theme.mode === 'dark' ? theme.dark.title : theme.light.title};
`;

const UnderConstruction = () => {
    return (
        <PageStyle>
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
                <H1>Under Construction</H1>
                <P>We are working hard to bring you something amazing. Please check back later!</P>
                
                <CraneContainer>
                    <Base />
                    <Mast />
                    <JibContainer>
                        <CounterJib />
                        <Jib />
                        <Trolley>
                            <Line>
                                <Hook>
                                    <Load />
                                </Hook>
                            </Line>
                        </Trolley>
                    </JibContainer>
                </CraneContainer>
            </div>
        </PageStyle>
    );
};

export default UnderConstruction;
